import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

const Header = ({ member, onShowAdmin, onToggleStatistics, statisticsOpen }) => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (member) {
      setIsAdmin(member.user_is_superuser || false);
    }
  }, [member]);
  const handleLogout = async () => { // eslint-disable-line no-unused-vars
    try {
      await apiService.logout();
      window.location.reload();
    } catch (error) {
      console.error('Fehler beim Logout:', error);
      window.location.reload();
    }
  };

  return (
    <header className="bg-transparent text-text-strong relative z-10">
      <div className="flex items-center justify-between px-4 py-3 h-14">
        {/* Titel */}
        <div className="flex items-center space-x-2">
          <img 
            src="/wachtel_icon.png" 
            alt="Wachtel Icon" 
            className="w-8 h-8 object-contain"
          />
          <div>
            <h1 className="font-heading font-bold text-xl tracking-wide">Wachtel Stammtisch</h1>
            <p className="text-text-subtle text-sm">Deine digitale Bierkasse</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {/* Statistik-Icon */}
          {onToggleStatistics && (
            <button
              type="button"
              onClick={onToggleStatistics}
              className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors duration-200 border-2 ${
                statisticsOpen
                  ? 'bg-accent-1 border-accent-2 text-white shadow-glow-accent'
                  : 'bg-accent-3 border-accent-1/30 text-accent-1 hover:bg-accent-2 hover:text-white'
              }`}
              title={statisticsOpen ? 'Statistik schließen' : 'Statistik'}
              aria-label={statisticsOpen ? 'Statistik schließen' : 'Statistik öffnen'}
              aria-pressed={statisticsOpen}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </button>
          )}
          {isAdmin && (
            <button
              type="button"
              onClick={onShowAdmin}
              className="w-8 h-8 bg-accent-1 rounded-full flex items-center justify-center text-sm font-semibold text-white hover:bg-accent-2 transition-colors duration-200"
            >
              A
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 